import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    group: '',
    course: '',
    teacher: '',
    student: '',
    assessment_type: '',
    created_at_from: '',
    created_at_to: '',
  },
}

export const gradebokAssessmentsUI = createSlice({
  name: 'gradebokAssessmentsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGroup: (state, { payload }) => {
      state.tableFilters.group = payload
    },
    setCourse: (state, { payload }) => {
      state.tableFilters.course = payload
    },
    setTeacher: (state, { payload }) => {
      state.tableFilters.teacher = payload
    },
    setStudent: (state, { payload }) => {
      state.tableFilters.student = payload
    },
    setAssessmentType: (state, { payload }) => {
      state.tableFilters.assessment_type = payload
    },
    setCreatedAtFromDate: (state, { payload }) => {
      state.tableFilters.created_at_from = payload
    },
    setCreatedAtToDate: (state, { payload }) => {
      state.tableFilters.created_at_to = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setGroup,
  setCourse,
  setTeacher,
  setStudent,
  setAssessmentType,
  setCreatedAtFromDate,
  setCreatedAtToDate,
  trackActiveFilters,
  clearAllFilters,
} = gradebokAssessmentsUI.actions

export default gradebokAssessmentsUI.reducer
